/* eslint-disable */
import jsPDF from 'jspdf'
import 'jspdf-autotable'
// import { encode64 } from '@/js/utils/base64'
// import { showSequence } from '@/js/survey/showSequence'
// import { showQuestion } from '@/js/survey/showQuestion'
import i18n from '@/plugins/i18n/i18n'
import logoDataEn from '@/assets/images/logo/BRPS-EN.png'
import logoDataFr from '@/assets/images/logo/BRPS-FR.png'
import logoDataNl from '@/assets/images/logo/BRPS-NL.png'
// import * as svfFirm from '@/assets/images/entreprise.svg'
// import 

export const makePDF = async (element, answerid, key, firm) => {

  const language = i18n.locale ? i18n.locale : 'fr'

  var logoUrl = language.toLowerCase() === 'fr' ? logoDataFr :
                language.toLowerCase() === 'nl' ? logoDataNl :
                language.toLowerCase() === 'en' ? logoDataEn : logoDataEn

  let imgData = null
  await toDataURL(logoUrl)
    .then(response => {
      imgData = response
    })
    .catch(() => {return})

  // console.log(element)

  var doc = new jsPDF()
  doc.addImage(imgData, 'JPEG', 5, 5, 55, 10) // set logo image
  
  if (firm) {
    doc.setFontSize(16)
    if(firm.title) doc.text(5, 25, firm.title)
    doc.setFontSize(10)
    if(firm.address || firm.zip || firm.city) doc.text(5, 30, `${firm.address ? firm.address : ' '}, ${firm.zip ? firm.zip : ' '} - ${firm.city ? firm.city : ' '}`) // show full address
    if(firm.vat) doc.text(5, 35, firm.vat) // show VAT num
    if(firm.nr) doc.text(5, 40, firm.nr) // show NR num
    if(firm.reg) doc.text(5, 45, firm.reg) // show REG num
  }


  // var today = new Date();
  // var date = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate()
  // var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()
  // var dateTime = date + ' ' + time
  var dateTime = unescaped(element.info.date)
  if (dateTime) {
    doc.text(160, 25, dateTime + ' :', {align:'right'}) // show Creation Date
  }

  var auditTitle = 'Audit'
  if (element) {

    auditTitle = unescaped(element.info[`title_${language}`])
    if (auditTitle) {
      doc.splitTextToSize(auditTitle, 180)
      doc.setFontSize(16)
      doc.text(160, 32, auditTitle, {maxWidth: 70, align:'right'})
    }

    const indice1 = i18n.messages[language]['final-report']['indice-label-1']
    const indice2 = i18n.messages[language]['final-report']['indice-label-2']
    const indice3 = i18n.messages[language]['final-report']['indice-label-3']

    const scoreLabel1 = i18n.messages[language]['certificate-request']['score-1']
    const scoreLabel2 = i18n.messages[language]['certificate-request']['score-2']
    const scoreLabel3 = i18n.messages[language]['certificate-request']['score-3']

    const points = i18n.messages[language]['certificate-request']['points']

    const score1 = Math.round((parseInt(element.done.question) / parseInt(element.total.question)) * 100)
    const score2 = parseInt(element.done.point)
    const score3 = parseInt(element.total.requiredpt)

    doc.autoTable({
      head: [[indice1, indice2, indice3]],
      body: [[`${score1}% ${scoreLabel1}`, `${scoreLabel2} ${score2} ${points}`, `${scoreLabel3} ${score3} ${points}`]],
      startY: 75,
      bodyStyles: {
        valign: 'top'
      },
      styles: {
        cellWidth: 'wrap',
        rowPageBreak: 'auto',
        halign: 'justify'
      },
      columnStyles: {
        text: {
          cellWidth: 'auto'
        }
      }
    })

  } else {
    doc.setFontSize(16)
    doc.text(5, 25, 'NO DATA FOUND')
  }

  var signatureTitle = i18n.messages[language]['general-info']['title']
  var signatureService1 = i18n.messages[language]['general-info']['service-1']
  var signatureService2 = i18n.messages[language]['general-info']['service-2']
  var signatureAddress = i18n.messages[language]['general-info']['address']
  var signatureZip = i18n.messages[language]['general-info']['zip']

  doc.setFontSize(10)
  if(signatureTitle) doc.text(5, 120, signatureTitle)
  if(signatureService1) doc.text(5, 125, signatureService1)
  if(signatureService2) doc.text(5, 130, signatureService2)
  if(signatureAddress) doc.text(5, 135, signatureAddress)
  if(signatureZip) doc.text(5, 140, signatureZip)
  
  var pdfName = 'PDF_audit.pdf'
  if (auditTitle && dateTime) {
    var composeName = auditTitle + '_' + dateTime
    pdfName = composeName.replace(/\s/g, '')
  }

  doc.save(pdfName)


  // toDataURL(logoUrl)
  //   .then(imgData => {


  //   })

  // var data = []
  // const currentLanguage = i18n.locale
  
  // const yes = i18n.messages[currentLanguage]['pdf']['yes']
  // const no = i18n.messages[currentLanguage]['pdf']['no']
  // const domain = i18n.messages[currentLanguage]['pdf']['domain']
  // const points = i18n.messages[currentLanguage]['pdf']['points']
  // const crit = i18n.messages[currentLanguage]['pdf']['crit']
  // const mandatory = i18n.messages[currentLanguage]['pdf']['mandatory']
  // const answer = i18n.messages[currentLanguage]['pdf']['answer']

  // for (var i = 0, len = element.sequences.length; i < len; i++) {
  //   const curSeq = i
  //   const params = {
  //     answerid: answerid,
  //     path: element.sequences[curSeq].path,
  //     sequenceid: element.sequences[curSeq].id,
  //     key: key
  //   }
  //   data[curSeq] = {}
  //   await showSequence(params)
  //     .then(async seq => {
  //       // Treat Sequence here
  //       data[curSeq].head = [[unescaped(seq.info[`title_${currentLanguage}`])]]
  //       data[curSeq].body = []
  //       // Then loop trought the questions sequences
  //       for (var i = 0, len = seq.questions.length; i < len; i++) {
  //         const params = {
  //           answerid: answerid,
  //           path: seq.questions[i].path,
  //           questionid: seq.questions[i].id,
  //           key: key
  //         }
  //         await showQuestion(params)
  //           .then(async quest => {
  //             // Treat Question here
  //             const questTitle = unescaped(quest.info[`title_${currentLanguage}`])

  //             // var countModuleType = ''

  //             for (var j = 0, len = quest.modules.length; j < len; j++) {
  //               // console.log(quest.modules[j])
  //               // console.log(quest.modules[j].type.indexOf('radio'), quest.modules[j].type)
  //               // const radio = quest.modules[j].type.indexOf('radio') && (countModuleType === quest.modules[j].type)
  //               // console.log(radio)

  //               if (quest.modules[j].type !== 'legend') {
  //                 await data[curSeq].body.push({
  //                   domain: j === 0 ? questTitle : '',
  //                   // points: j === 0  ? `${quest.done.point} / ${quest.total.point ? quest.total.point : '0'}` : '',
  //                   points: j === 0  ? quest.done.point : '',
  //                   crit: unescaped(quest.modules[j][`label_${currentLanguage}`]),
  //                   mandatory: quest.modules[j].mandatory === 'yes' ? yes : no,
  //                   answer: quest.modules[j].answer != '' ? yes : no
  //                 })
  //               }
  //               // if (quest.modules[j].type.indexOf('radio')) countModuleType = quest.modules[j].type
  //             }
  //           })
  //           // .catch(error => console.log(error))
  //       }
  //     })
  //     // .catch(error => console.log(error))
  // }


  // const doc = new jsPDF()

  // for (var i = 0, len = data.length; i < len; i++) {
  //   doc.autoTable({
  //     head: data[i].head
  //   })

  //   doc.autoTable({
  //     body: data[i].body,
  //     columns: [
  //       {header: domain, dataKey: 'domain'},
  //       {header: points, dataKey: 'points'},
  //       {header: crit, dataKey: 'crit'},
  //       {header: mandatory, dataKey: 'mandatory'},
  //       {header: answer, dataKey: 'answer'} ],
  //     columnStyles: {
  //       0: {halign: 'left', fillColor: [255, 255, 255], cellWidth: 40},
  //       1: {halign: 'center', fillColor: [255, 255, 255], cellWidth: 20},
  //       2: {cellWidth: 80},
  //       3: {halign: 'center', cellWidth: 20},
  //       4: {halign: 'center', cellWidth: 20}
  //     }
  //   })
  // }
  // doc.setFontSize(10)
  // doc.save('PDF.pdf')
}

const toDataURL = url => fetch(url)
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  }))


const unescaped = string => {
  var txt = document.createElement('textarea')
  txt.innerHTML = string
  return txt.value
}
